// @ts-nocheck
export const imageInterpreter = (images = null) => {
    if (!images || !images.data) return [];
    
    if (Array.isArray(images)) {
        return images.map(img => (typeof img === 'string' ? img : img.attributes?.url));
    }

    // Handle both images[n].attributes.url and images.data[n].attributes.url
    return (images.data || images)?.map(img => img?.attributes?.url).filter(Boolean) ?? [];
};

export const imageCacher = (posts, vxiContents) => {
    const urlSet = new Set();

    // Ensure posts is an array before calling forEach
    if (Array.isArray(posts)) {
        posts.forEach((post) => {
            // Share image
            const shareImage = post?.seo?.shareImage?.data?.attributes?.url;
            if (shareImage) urlSet.add(shareImage);

            // Sections
            const sections = post?.attributes?.section || [];
            sections.forEach((sect) => {
                switch (sect.__component) {
                    case "layout.hero":
                    case "layout.image-text-split":
                    case "layout.banner":
                    case "layout.narrative-slider":
                        sect?.images?.data?.forEach((img) => {
                            const url = img?.attributes?.url;
                            if (url) urlSet.add(url);
                        });
                        break;

                    case "layout.features-elevator":
                        sect?.floorPanel?.forEach((floor) => {
                            floor?.images?.data?.forEach((img) => {
                                const url = img?.attributes?.url;
                                if (url) urlSet.add(url);
                            });
                        });
                        break;
                }
            });
        });
    } else {
        console.warn("Posts is not an array:", posts);
    }

    if (Array.isArray(vxiContents)) {
        vxiContents.forEach((content) => {
            // Share image
            const shareImage = content?.seo?.shareImage?.data?.attributes?.url;
            if (shareImage) urlSet.add(shareImage);

            // Singular vxiContent
            const vxiContent = content?.attributes?.vxiContent;
            vxiContent?.images?.data?.forEach((img) => {
                const url = img?.attributes?.url;
                if (url) urlSet.add(url);
            });
        });
    } else {
        console.warn("vxiContents is not an array:", vxiContents);
    }

    const uniqueUrls = Array.from(urlSet);
    //console.log(uniqueUrls);
    return uniqueUrls;
};


